<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h5>Nova Plano Conta Matriz</h5>
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="id">Código</label>
							<input name="id" type="number" pInputText placeholder="Informe o código" ngModel
								#id="ngModel" />
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="descricao">Descrição</label>
							<input oninput="this.value = this.value.toUpperCase();" name="descricao" type="text"
								pInputText placeholder="Digite a descrição" ngModel
								#descricao="ngModel" required />
							<div *ngIf="descricao.hasError('required') && descricao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>

						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="especificacao">Especificação</label>
							<input oninput="this.value = this.value.toUpperCase();" name="especificacao" type="text"
								pInputText placeholder="Digite a especificação" ngModel
								#especificacao="ngModel" required />
							<div *ngIf="especificacao.hasError('required') && especificacao.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>

						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="dre">DRE</label>
							<p-dropdown [options]="dadosDre" placeholder="Selecione" name="dre" ngModel
								#dre="ngModel" [required]="true" >
							</p-dropdown>
							<div *ngIf="dre.hasError('required') && dre.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="planoContaGrupo">Plano Conta Grupo</label>
							<p-dropdown [options]="planosContaGrupos" optionLabel="descricao" [filter]="true"
								placeholder="Selecione" name="planoContaGrupo" ngModel #planoContaGrupo="ngModel"
								[required]="true" [(ngModel)]="grupoSelecionado">
							</p-dropdown>
							<div *ngIf="planoContaGrupo.hasError('required') && planoContaGrupo.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="utilizacao">Utilização</label>
							<p-dropdown [options]="utilizacoes" placeholder="Selecione" name="utilizacao" ngModel
								#utilizacao="ngModel" [required]="true">
							</p-dropdown>
						</div>
						<div class="field col-12 md:col-2" *ngIf="grupoSelecionado?.id === 3">
							<label htmlFor="referenciaFolha">Referência Folha</label>
							<p-dropdown [options]="referenciasFolha" placeholder="Selecione" name="referenciaFolha" ngModel
								#referenciaFolha="ngModel" [required]="true">
							</p-dropdown>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="prioridade">Prioridade</label>
							<p-dropdown [options]="prioridades" optionLabel="label" optionValue="value" [filter]="true"
								placeholder="Selecione" name="prioridade" ngModel #prioridade="ngModel"
								[required]="true">
							</p-dropdown>
						</div>

						<div class="field col-12 md:col-2">
							<label htmlFor="configuravel">Configuravel</label>
							<br>
							<p-inputSwitch name="configuravel"
								[(ngModel)]="configuravel"></p-inputSwitch>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="submit" pButton icon="pi pi-check" label="Salvar" (click)="salvar()"
								class="p-button-success mt-5" [disabled]="!f.valid"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="button" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-8">

						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" routerLink="/rfarias/plano-contas-matriz"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>